import {
  GetInvoicePaymentLinkDto,
  GetInvoicePaymentLinkDtoTypeEnum,
  GetSalesInvoiceDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';

export type PendingLinkType = GetInvoicePaymentLinkDtoTypeEnum;

export interface PendingLink {
  key: string;
  type: PendingLinkType;
  existingId?: string;
  salesInvoiceId: string;
  receiptId?: string | null;
  systemNumber?: number | null;
  number?: string | null;
  contractorName?: string | null;
  amountGross?: string | null;
  salesInvoiceTotalLinkedAmount?: string | null;
  unlinkedAmount: string;
  comment?: string | null;
  originalComment?: string | null;
  amount: string;
  originalAmount: string;
  toDelete: boolean;
}

export const sortBySystemNumber = (links: PendingLink[]): PendingLink[] =>
  [...links].sort((a, b) => (a.systemNumber ?? 0) - (b.systemNumber ?? 0));

export const resolveContractorName = (
  inv: GetInvoicePaymentLinkDto['salesInvoice'],
): string | null => {
  if (!inv) {
    return null;
  }
  if (inv.company?.name) {
    return inv.company.name;
  }
  if (inv.examined?.invoiceName) {
    return inv.examined.invoiceName;
  }
  const parts = [inv.examined?.surname, inv.examined?.firstname].filter(
    Boolean,
  );
  return parts.length > 0 ? parts.join(' ') : null;
};

export const toPending = (link: GetInvoicePaymentLinkDto): PendingLink => ({
  key: link.id,
  type: link.type,
  existingId: link.id,
  salesInvoiceId: link.salesInvoice?.id ?? '',
  receiptId: link.receiptId ?? null,
  systemNumber: link.salesInvoice?.systemNumber,
  number: link.salesInvoice?.number,
  contractorName: resolveContractorName(link.salesInvoice),
  amountGross: link.salesInvoice?.amountGross ?? null,
  salesInvoiceTotalLinkedAmount: link.salesInvoiceTotalLinkedAmount,
  unlinkedAmount: link.salesInvoiceUnlinkedAmount ?? '',
  comment: link.comment,
  originalComment: link.comment,
  amount: link.amount ?? '',
  originalAmount: link.amount ?? '',
  toDelete: false,
});

export const toPendingFromInvoice = (inv: GetSalesInvoiceDto): PendingLink => ({
  key: `new-${inv.id}`,
  type: GetInvoicePaymentLinkDtoTypeEnum.Invoice,
  salesInvoiceId: inv.id,
  systemNumber: inv.systemNumber,
  number: inv.number,
  contractorName:
    inv.company?.name ??
    inv.examined?.invoiceName ??
    ([inv.examined?.surname, inv.examined?.firstname]
      .filter(Boolean)
      .join(' ') ||
      null),
  amountGross: inv.amountGross ?? null,
  salesInvoiceTotalLinkedAmount: '0',
  unlinkedAmount: inv.amountGross ?? '0',
  comment: null,
  originalComment: null,
  amount: '0',
  originalAmount: '',
  toDelete: false,
});

export const toPendingFromLink = (
  link: GetInvoicePaymentLinkDto,
  invoiceId: string,
): PendingLink => ({
  key: `new-${invoiceId}`,
  type: GetInvoicePaymentLinkDtoTypeEnum.Invoice,
  salesInvoiceId: invoiceId,
  systemNumber: link.salesInvoice?.systemNumber,
  number: link.salesInvoice?.number,
  contractorName: resolveContractorName(link.salesInvoice),
  amountGross: link.salesInvoice?.amountGross ?? null,
  salesInvoiceTotalLinkedAmount: link.salesInvoiceTotalLinkedAmount,
  unlinkedAmount: link.salesInvoiceUnlinkedAmount ?? '',
  comment: null,
  originalComment: null,
  amount: '0',
  originalAmount: '',
  toDelete: false,
});
